import makeStyles from "@material-ui/core/styles/makeStyles";
import theme from "styles/theme";

import { STYLE_TOKENS } from "../../style-tokens";

export const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    label: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: theme.fontFamily,
        marginBottom: "5px",
        color: STYLE_TOKENS.COLORS.colCarbonFiber,
    },
    asterix: {
        fontSize: "14px",
        fontWeight: 700,
        fontFamily: theme.fontFamily,
        color: STYLE_TOKENS.COLORS.colRaceCarStripe,
    },
    input: {
        "&$input": {
            fontSize: "14px",
            fontWeight: 400,
            height: "40px",
            fontFamily: theme.fontFamily,
            borderRadius: STYLE_TOKENS.BORDERS.RADIUS.FIELD.default,
            border: `1px solid ${STYLE_TOKENS.COLORS.colDoubleClick}`,
            padding: "3px 6px",
            color: STYLE_TOKENS.COLORS.colCarbonFiber,
            backgroundColor: STYLE_TOKENS.COLORS.colWhite,
            width: "100%",

            "&:focus": {
                border: `1px solid ${STYLE_TOKENS.COLORS.colDoubleClick}`,
                outline: `2px solid ${STYLE_TOKENS.COLORS.colIceBlue}`,
                outlineOffset: "2px",
            },
        },
    },
    inputError: {
        "&$inputError": {
            borderColor: STYLE_TOKENS.COLORS.colStrawberryRose,
            backgroundColor: STYLE_TOKENS.COLORS.colIvoryTower,

            "&:focus": {
                borderColor: STYLE_TOKENS.COLORS.colStrawberryRose,
            },
        },
    },
    error: {
        display: "flex",
        alignItems: "center",
        color: STYLE_TOKENS.COLORS.colToryRed,
        fontFamily: theme.fontFamily,
        fontWeight: 400,
        fontSize: "14px",
        marginTop: "5px",
    },
    errorIcon: {
        color: STYLE_TOKENS.COLORS.colToryRed,
        marginRight: "5px",
    },
    helperText: {
        fontSize: "12px",
        fontWeight: 400,
        fontFamily: theme.fontFamily,
        color: STYLE_TOKENS.COLORS.colCarbonFiber,
        marginTop: "5px",
    },
    startIcon: {
        position: "absolute",
        display: "flex",
        height: "100%",
        alignItems: "center",
        left: "12px",
    },
    hasStartIcon: {
        "&$hasStartIcon": {
            paddingLeft: "44px",
        },
    },
}));
